import PhotoVariant from "src/api/graphql/__generated__/enums/PhotoVariant";
import { PersistAssetInfo } from "../types";

const parseFileToAsset = (
	file: File,
	{
		localSelectionId,
		localSelectionIndex,
	}: { localSelectionIndex: number; localSelectionId: string },
): PersistAssetInfo => {
	if (file.type.startsWith("video")) {
		return {
			type: "file",
			variant: PhotoVariant.Video,
			localSelectionId,
			localSelectionIndex,
			video: {
				file: file,
			},
		};
	} else {
		return {
			type: "file",
			variant: PhotoVariant.Image,
			localSelectionId,
			localSelectionIndex,
			image: {
				file: file,
			},
		};
	}
};
export default parseFileToAsset;
